import { Component, AfterViewInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbPanelChangeEvent, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingService } from './../../services/setting.service';
import { UserService } from './../../services/user.service';
import { RoleService } from './../../services/role.service';


declare var $: any;
@Component({
    selector: 'ap-navigation',
    templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {
    name: string;
    user_id:any=0;
    role_id:any=0;
    company_id:any=0;
    model:any={}
    APIKEY:any= '';
    profileData:any={};
    imagePath:any='assets/images/users/profile_pic.png';
    message:string;
    company_setting_per:boolean=false;
    user_profile_image:any;
    loginType:any= '';
    adminId:any= 0;
    

    constructor(
        private modalService: NgbModal,
        private _setting:SettingService,
        private toastr: ToastrService,
        private _activatedroute: ActivatedRoute,
        private _router : Router,
        private _role:RoleService,private _User:UserService,) {
    }
    ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.role_id =localStorage.getItem('role_id');
    this.APIKEY =localStorage.getItem('APIKEY');
    this.loginType =localStorage.getItem('loginType');
    this.adminId =localStorage.getItem('adminId');
    this.model= { 
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        role_id : this.role_id,
        company_id : this.company_id
     };

      this._setting.getProfileInfo(this.model)
      .subscribe(
        res => { 
             //console.log(res.data.image_url);  
             if(res.data.image_url=='' || res.data.image_url==null){
                this.user_profile_image=this.imagePath;

             }else{
                this.user_profile_image=res.data.image_url;
             }
            
            this.profileData= res.data;
         },
      );


    //// top navigation use 
    this._setting.CurrentProfile.subscribe(
     res => {
         this.profileData = res; 
       }
    );
   ///end 


    if(this.role_id==1 || this.role_id==2 || this.role_id==3){
        this.company_setting_per=true;  
    }
    else{
        this._role.getRolePer(this.model)
        .subscribe(
          res => { 
            if((res.data[0].role_name)!='Mobile User'){
                if(res.data[5].module_name=='Company_Setting' && res.data[5].checked==1){
                        this.company_setting_per=true;
                }  
            }
          },
        );

    }




    }


    superAdminLogin(value){ //alert(value);
        const data= {
            APIKEY : this.APIKEY,
            edit_userid : value,
            company_id : this.company_id,
        }
      
        this._User.getUserInfo(data)
          .subscribe(
            res => {
                  // console.log(res); return false;
                    if(res.status==true){
                        // this.spinnerService.hide();
                        var  role_info = res.data.role.split("-")


                        localStorage.setItem('currentUser', JSON.stringify(res));
                        localStorage.setItem("id",res.data.id);
                        localStorage.setItem("company_id",res.data.company_id);
                        localStorage.setItem("role_id",role_info[0]);
                        localStorage.removeItem('loginType');
                        localStorage.removeItem('adminId');
                        this._router.navigate(["/super-admin/customer-list/active"]);
                   
                    
                    }
              
            },
            err => console.log(err)
         );
       }
   


 





    ngAfterViewInit() {
        var set = function () {
            var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
            var topOffset = 0;
            if (width < 1170) {
                $("#main-wrapper").addClass("mini-sidebar");
            } else {
                $("#main-wrapper").removeClass("mini-sidebar");
            }
        };
        $(window).ready(set);
        $(window).on("resize", set);


        $(".search-box a, .search-box .app-search .srh-btn").on('click', function () {
            $(".app-search").toggle(200);
        });
        $("body").trigger("resize");
    }
}
